<template>
  <v-autocomplete
      :items="venuesTags"
      v-model="venuesSelectedTags"
      :search-input.sync="tagsSearchInput"
      :label="$t('general.tags')"
      @click:append-outer="appendTag"
      @keypress.enter="appendTag"
      color="kbDarkBlue"
      prepend-icon="mdi-label"
      clear-icon="mdi-close-circle"
      append-outer-icon="mdi-plus"
      multiple
      clearable
      open-on-clear
  >
    <template v-slot:selection="{ item, index }">
      <v-chip
        class="ma-2"
        color="kbDarkBlue"
        label
        text-color="white"
        close
        @click:close="spliceTag(index)"
      >
        <v-icon left>
          mdi-label
        </v-icon>
        {{item}}
      </v-chip>
    </template>
    <template slot="no-data">
      <v-btn color="kbGold" style="width: 97%;" class="mx-2" dark @click="appendTag">
        {{$t('general.createTag')}}
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'

export default {
  mounted () {
    this.$store.dispatch('getVenuesTags')
  },
  computed: {
    ...mapState({
    }),
    venuesSelectedTags: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    venuesTags: {
      get () {
        return this.$store.state.events.venuesTags
      },
      set (value) {
        this.$store.commit('SET_VENUES_TAGS', value)
      }
    }
  },
  data () {
    return {
      tagsSearchInput: ''
    }
  },
  methods: {
    appendTag () {
      // TODO: validate element is not in the array
      if (this.tagsSearchInput) {
        this.venuesTags.push(this.tagsSearchInput)
        this.venuesSelectedTags.push(this.tagsSearchInput)
      } else {
        notifications.info(this.$t('general.tagsHint'))
      }
    },
    spliceTag (idx) {
      this.venuesSelectedTags.splice(idx, 1)
    }
  },
  props: {
    value: {
      required: true
    }
  }
}
</script>
